import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92774fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settingWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CellGroup = _resolveComponent("CellGroup")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar, { title: "Setting" }),
    _createVNode(_component_Field, {
      center: "",
      clearable: "",
      label: "是否开启文件鉴权",
      placeholder: "是否开启文件鉴权"
    }, {
      input: _withCtx(() => [
        _createVNode(_component_Switch, {
          size: "large",
          onChange: _ctx.setting.changeAuthFile,
          modelValue: _ctx.setting.isAuthFile,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setting.isAuthFile) = $event))
        }, null, 8, ["onChange", "modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, null, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.pageSize,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.setting.pageSize) = $event)),
          center: "",
          clearable: "",
          label: "isMarked",
          placeholder: "是否标记会话"
        }, {
          input: _withCtx(() => [
            _createVNode(_component_Switch, {
              size: "large",
              modelValue: _ctx.setting.isMarked,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.setting.isMarked) = $event))
            }, null, 8, ["modelValue"])
          ]),
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.markConversation
            }, {
              default: _withCtx(() => [
                _createTextVNode("标记会话")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.userID,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.setting.userID) = $event)),
          center: "",
          clearable: "",
          label: "添加好友",
          placeholder: "请输入好友ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.addFriend
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.delUserID,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.setting.delUserID) = $event)),
          center: "",
          clearable: "",
          label: "删除好友",
          placeholder: "请输入好友ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "danger",
              onClick: _ctx.setting.delFriend
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.blockStr,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.setting.blockStr) = $event)),
          rows: "1",
          autosize: "",
          label: "黑名单列表",
          type: "textarea",
          center: "",
          placeholder: "黑名单"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              size: "small",
              onClick: _ctx.setting.getBlockList
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.blockId,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.setting.blockId) = $event)),
          center: "",
          clearable: "",
          label: "加入黑名单",
          placeholder: "请输入好友ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.addBlock
            }, {
              default: _withCtx(() => [
                _createTextVNode("加入")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.delBlockId,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.setting.delBlockId) = $event)),
          center: "",
          clearable: "",
          label: "移除黑名单",
          placeholder: "请输入好友ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "danger",
              onClick: _ctx.setting.delBlock
            }, {
              default: _withCtx(() => [
                _createTextVNode("移除")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.groupId,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.setting.groupId) = $event)),
          center: "",
          clearable: "",
          label: "加入群组",
          placeholder: "请输入群组ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "danger",
              onClick: _ctx.setting.joinGroup
            }, {
              default: _withCtx(() => [
                _createTextVNode("加入")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.roomId,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.setting.roomId) = $event)),
          center: "",
          clearable: "",
          label: "聊天室ID",
          placeholder: "请输入聊天室ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"margin-right":"10px"},
              size: "small",
              type: "primary",
              onClick: _ctx.setting.joinRoom
            }, {
              default: _withCtx(() => [
                _createTextVNode("加入")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              size: "small",
              type: "danger",
              onClick: _ctx.setting.leaveRoom
            }, {
              default: _withCtx(() => [
                _createTextVNode("离开")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.infoGroupId,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.setting.infoGroupId) = $event)),
          center: "",
          clearable: "",
          label: "获取群组信息",
          placeholder: "请输入群组ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "danger",
              onClick: _ctx.setting.getGroupInfo
            }, {
              default: _withCtx(() => [
                _createTextVNode("获取")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.remark,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.setting.remark) = $event)),
          center: "",
          clearable: "",
          label: "设置好友备注",
          placeholder: "请输入好友备注"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.setRemark
            }, {
              default: _withCtx(() => [
                _createTextVNode("设置")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.allContacts,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.setting.allContacts) = $event)),
          center: "",
          clearable: "",
          label: "联系人列表",
          placeholder: "联系人列表"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getAllContacts
            }, {
              default: _withCtx(() => [
                _createTextVNode("获取所有联系人")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.cursorContacts,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.setting.cursorContacts) = $event)),
          center: "",
          clearable: "",
          label: "分页联系人列表",
          placeholder: "联系人列表"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getContactsWithCursor
            }, {
              default: _withCtx(() => [
                _createTextVNode("联系人列表")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_Tag, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode("分页配置")
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.cursor,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.setting.cursor) = $event)),
          center: "",
          clearable: "",
          label: "Cursor",
          placeholder: "请输入cursor,默认为空"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.pageSize,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.setting.pageSize) = $event)),
          center: "",
          clearable: "",
          label: "PageSize",
          placeholder: "请输入pageSize"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_Tag, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode("会话标记")
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.conversationId,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.setting.conversationId) = $event)),
          center: "",
          clearable: "",
          label: "会话ID",
          placeholder: "请输会话ID"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.conversationType,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.setting.conversationType) = $event)),
          center: "",
          clearable: "",
          label: "会话类型",
          placeholder: "请输入会话类型"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.mark,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.setting.mark) = $event)),
          center: "",
          clearable: "",
          label: "会话标记",
          placeholder: "请输入会话标记"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.pageSize,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.setting.pageSize) = $event)),
          center: "",
          clearable: "",
          label: "isMarked",
          placeholder: "是否标记会话"
        }, {
          input: _withCtx(() => [
            _createVNode(_component_Switch, {
              size: "large",
              modelValue: _ctx.setting.isMarked,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.setting.isMarked) = $event))
            }, null, 8, ["modelValue"])
          ]),
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.markConversation
            }, {
              default: _withCtx(() => [
                _createTextVNode("标记会话")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.filterConversations,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.setting.filterConversations) = $event)),
          center: "",
          clearable: "",
          label: "会话列表",
          placeholder: "请输会话ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getServerConversationsByFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode("根据标记分页获取会话列表")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_Tag, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode("会话列表")
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          center: "",
          clearable: "",
          label: "会话列表",
          placeholder: "请输会话ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getServerConversations
            }, {
              default: _withCtx(() => [
                _createTextVNode("获取服务端会话列表")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          center: "",
          clearable: "",
          label: "会话列表",
          placeholder: "请输会话ID"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getServerPinnedConversations
            }, {
              default: _withCtx(() => [
                _createTextVNode("获取服务端置顶会话列表")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Tag, { type: "success" }, {
      default: _withCtx(() => [
        _createTextVNode("Presence")
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.presenceDesc,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.setting.presenceDesc) = $event)),
          center: "",
          clearable: "",
          label: "在线状态",
          placeholder: "请输入在线状态"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.publishPresence
            }, {
              default: _withCtx(() => [
                _createTextVNode("发布在线状态")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.expiry,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.setting.expiry) = $event)),
          center: "",
          clearable: "",
          label: "订阅时长",
          placeholder: "请输入订阅时长"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.subscribePresence
            }, {
              default: _withCtx(() => [
                _createTextVNode("订阅状态")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          center: "",
          clearable: "",
          label: "取消订阅",
          placeholder: ""
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.unsubscribePresence
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消订阅")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          center: "",
          clearable: "",
          label: "获取订阅用户在线状态",
          placeholder: ""
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getSubscribedPresenceList
            }, {
              default: _withCtx(() => [
                _createTextVNode("分野查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          center: "",
          clearable: "",
          label: "获取指定用户在线状态",
          placeholder: ""
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getPresenceStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.joinedChatRoomsParams,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.setting.joinedChatRoomsParams) = $event)),
          center: "",
          clearable: "",
          label: "获取当前用户加入的聊天室",
          placeholder: "请求参数格式 pageNum=1&pageSize=20&needRole=true&needAffiliations=true"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.getJoinedChatRooms
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_CellGroup, { inset: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_Field, {
          modelValue: _ctx.setting.chatRoomId,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.setting.chatRoomId) = $event)),
          center: "",
          clearable: "",
          label: "解散聊天室",
          placeholder: "请输入Chatroom ID "
        }, {
          button: _withCtx(() => [
            _createVNode(_component_Button, {
              size: "small",
              type: "primary",
              onClick: _ctx.setting.destroyChatRoom
            }, {
              default: _withCtx(() => [
                _createTextVNode("解散")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}